import React from "react";
import styled from "styled-components";
import Footer from "~/components/Footer";
import { PublicPageSeo } from "~/components/Seo";
import Header from "~/guidelines/Header";
import mediaQueries from "~/guidelines/Theme/mediaQueries";
import { heading3 } from "~/guidelines/Typography";

export const CenteredSection = styled.section`
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;

  padding: ${({ theme }) => theme.spacing(4, 5)};

  ${mediaQueries.sm()} {
    padding: ${({ theme }) => theme.spacing(8, 5)};
  }
`;

export const TitleRow = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing(6)};
`;

export const SectionTitle = styled.h3`
  margin: 0;
  ${heading3};

  & em {
    font-style: normal;
    color: ${({ theme }) => theme.color.text.lightTertiary};
  }
`;

export const StayOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaQueries.md()} {
    align-items: flex-start;
  }
`;

export const SearchSummaryOnDesktopSection = styled(CenteredSection)`
  display: none;

  ${mediaQueries.md()} {
    display: block;
    padding: ${({ theme }) => theme.spacing(8, 5, 6, 5)};
  }

  ${mediaQueries.xl()} {
    padding-top: ${({ theme }) => theme.spacing(13)};
  }
`;

export const SearchSummaryOnMobileSection = styled(CenteredSection)`
  display: grid;
  grid-template-columns: 1fr max-content 1fr;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
  padding: ${({ theme }) => theme.spacing(6, 5)};

  ${mediaQueries.xxsOnly()} {
    grid-template-columns: min-content min-content;
  }

  ${mediaQueries.md()} {
    display: none;
  }
`;

export const LogesFilterOnMobileSection = styled(CenteredSection)`
  padding: ${({ theme }) => theme.spacing(5)};

  ${mediaQueries.md()} {
    display: none;
  }
`;

export const AccommodationsSection = styled(CenteredSection)`
  padding-top: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
`;

const Container = styled.div`
  min-height: 100vh; /* help having the most possible 100vh equivalent for mobiles */
  min-height: 100svh; /* Safari 14 now support it! */
  display: grid;
  grid-template-rows: auto 1fr auto;
  background-color: ${({ theme }) => theme.color.background.lightSecond};
`;

type OfferSearchLayoutProps = {
  head: React.ReactNode;
  header: React.ReactElement<typeof Header>;
  children: React.ReactNode;
  footer: React.ReactElement<typeof Footer>;
};

const OfferSearchLayout = ({
  head,
  header,
  children,
  footer,
}: OfferSearchLayoutProps) => {
  return (
    <>
      {head}
      <PublicPageSeo />
      <Container>
        {header}
        {children}
        {footer}
      </Container>
    </>
  );
};

export default OfferSearchLayout;
